/** Метаданные для галереи фонов сервисов мега-приложения (перенос в Figma, согласование с командой). */
export type ScreenBackgroundGalleryKey =
  | "hub"
  | "oauth"
  | "print"
  | "payment"
  | "link"
  | "referral"
  | "sub";

export interface ScreenBackgroundGalleryItem {
  key: ScreenBackgroundGalleryKey;
  title: string;
  description: string;
}

export const screenBackgroundGalleryItems: ScreenBackgroundGalleryItem[] = [
  {
    key: "hub",
    title: "Hub — основной сервис",
    description:
      "Мега-оболочка: #3c3962 → #6d5f94. Link светлее сверху, print темнее; низ print #5d5084, hub/link/sub #6d5f94."
  },
  {
    key: "oauth",
    title: "OAuth — вход и доверие",
    description:
      "Сплошной тёмный #222222 (DomainScreenBackground). Нейтральный, без градиента — акцент на форме и бренде, не на «области сервиса»."
  },
  {
    key: "print",
    title: "Print — печать / продакшн",
    description:
      "Основной продукт: #2e2b46 → #5d5084 — плотнее hub, низ глубже общего лавандового #6d5f94."
  },
  {
    key: "payment",
    title: "Payment — оплата",
    description:
      "Тот же плоский #222222, что и OAuth (PaymentDomainScreenBackground), пока визуально спокойный чек-аут. При необходимости позже добавьте лёгкий акцент только в UI-компонентах, не меняя заливку."
  },
  {
    key: "link",
    title: "Link — ссылки и шаринг",
    description:
      "Первый контакт: #4a4574 → #6d5f94 — светлее hub сверху, тот же низ, в одной семье с мега-приложением."
  },
  {
    key: "referral",
    title: "Referral — реферальная программа",
    description:
      "Доп. сервис: #201d31 → #3c3962 — чуть более холодный, нижняя точка совпадает с верхом hub (стыкуется с линейкой, но с другим настроением)."
  },
  {
    key: "sub",
    title: "Sub — общие подстраницы",
    description:
      "Настройки, профиль, FAQ: #222222 → #6d5f94. Общий «вторичный» хром приложения; не основной продуктовый поток."
  }
];
